module.exports = __webpack_public_path__ + "images/nationalenederlanden2fe0e43e975de323b06323fc1468d8db.png";